// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9840ac95","453":"08971413","455":"367f5ae9","977":"707546f5"}[chunkId] + ".chunk.js";
};